import { formatDate } from "@/lib/utils";
import React from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
} from "@/components/ui/dialog";
import { Badge } from "@/components/ui/badge";


const ExpenseDetailsModal = ({ isOpen, onClose, expense }) => {
  if (!expense) return null;

  const renderStatus = (status) => {
    const mapping = {
      draft: "secondary",
      pending_approval: "warning",
      approved: "default",
      rejected: "destructive",
      paid: "success",
    };
    const variant = mapping[status] || "secondary";
    return (
      <Badge variant={variant} className="capitalize">
        {status?.replace(/_/g, " ")}
      </Badge>
    );
  };

  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-2xl max-h-[90vh] overflow-y-auto">
        <DialogHeader>
          <DialogTitle>Expense Details</DialogTitle>
        </DialogHeader>
        <div className="space-y-6 py-4">
          <div className="grid grid-cols-2 gap-4">
            <div>
              <p className="text-sm text-muted-foreground">Title</p>
              <p className="font-medium">{expense.title || "-"}</p>
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Status</p>
              <div>{renderStatus(expense.status)}</div>
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Category</p>
              <p className="font-medium">{expense.category?.name || "-"}</p>
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Supplier</p>
              <p className="font-medium">{expense.supplier?.name || "-"}</p>
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Employee</p>
              <p className="font-medium">
                {expense.employee?.full_name || "-"}
              </p>
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Payment Method</p>
              <p className="font-medium capitalize">
                {expense.payment_method?.replace(/_/g, " ") || "-"}
              </p>
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Expense Date</p>
              <p className="font-medium">
                {expense.expense_date
                  ? formatDate(new Date(expense.expense_date))
                  : "-"}
              </p>
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Created At</p>
              <p className="font-medium">
                {expense.created_at
                  ? formatDate(new Date(expense.created_at))
                  : "-"}
              </p>
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Reference Number</p>
              <p className="font-medium">{expense.reference_number || "-"}</p>
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Receipt Number</p>
              <p className="font-medium">{expense.receipt_number || "-"}</p>
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Creator</p>
              <p className="font-medium">{expense.creator?.full_name || "-"}</p>
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Approver</p>
              <p className="font-medium">
                {expense.approver?.full_name || "-"}
              </p>
            </div>
          </div>

          <div className="border rounded-lg p-4 bg-muted/50 grid grid-cols-3 gap-4">
            <div>
              <p className="text-sm text-muted-foreground">Amount</p>
              <p className="font-medium">{expense.amount || 0}</p>
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Tax Amount</p>
              <p className="font-medium">{expense.tax_amount || 0}</p>
            </div>
            <div>
              <p className="text-sm text-muted-foreground">Total Amount</p>
              <p className="font-bold text-lg">{expense.total_amount || 0}</p>
            </div>
          </div>

          {expense.description && (
            <div>
              <p className="text-sm text-muted-foreground mb-1">Description</p>
              <div
                className="text-sm border rounded p-3 bg-background"
                dangerouslySetInnerHTML={{ __html: expense.description }}
              />
            </div>
          )}

          {expense.notes && (
            <div>
              <p className="text-sm text-muted-foreground mb-1">Notes</p>
              <div
                className="text-sm border rounded p-3 bg-background"
                dangerouslySetInnerHTML={{ __html: expense.notes }}
              />
            </div>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ExpenseDetailsModal;
